export const environment = {
  production: false,
  apiUrl: 'https://amfshopvn.vn/api'
};
